import {
  CREATE_PRODUCT,
  CREATE_PRODUCTS_PRESENTATIONS,
  DELETE_PRODUCT,
  DELETE_PRODUCTS_PRESENTATIONS,
  EDIT_PRODUCT,
  EDIT_PRODUCTS_PRESENTATIONS,
  ERROR_PRODUCT,
  GET_PRODUCT,
  IS_LOADING_PRODUCT,
  IS_LOADING_PRODUCTS,
  LIST_OF_PRODUCTS,
  LIST_OF_PRODUCTS_PRESENTATIONS,
  IS_LOADING_REPORT_BY_TYPE,
  REPORT_BY_TYPE,
  IS_LOADING_UTILITY_REPORT,
  UTILITY_REPORT,
} from "../actions/types";

const initialState = {
  isLoadingProductsList: false,
  isLoadingProduct: false,
  productsList: [],
  product: null,
  presentations: [],
  isLoadingReportByType: false,
  reportByType: {},
  isLoadingUtilityReport: false,
  utilityReport: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case IS_LOADING_PRODUCT:
      return { ...state, isLoadingProduct: true };
    case GET_PRODUCT:
      return { ...state, product: action.payload, isLoadingProduct: false };
    case IS_LOADING_PRODUCTS:
      return { ...state, isLoadingProductsList: true };
    case LIST_OF_PRODUCTS:
      return {
        ...state,
        productsList: action.payload,
        isLoadingProductsList: false,
      };

    case IS_LOADING_REPORT_BY_TYPE:
      return { ...state, isLoadingReportByType: true };
    case REPORT_BY_TYPE:
      return {
        ...state,
        reportByType: action.payload,
        isLoadingReportByType: false,
      };

    case IS_LOADING_UTILITY_REPORT:
      return { ...state, isLoadingUtilityReport: true };
    case UTILITY_REPORT:
      return {
        ...state,
        utilityReport: action.payload,
        isLoadingUtilityReport: false,
      };

    case CREATE_PRODUCTS_PRESENTATIONS:
      return {
        ...state,
        presentations: [...state.presentations, action.payload],
      };
    case EDIT_PRODUCTS_PRESENTATIONS:
      const presentations = state.presentations.map((presentation) => {
        if (presentation._id === action.payload._id) {
          presentation.name = action.payload.name;
        }
        return presentation;
      });

      return { ...state, presentations };
    case LIST_OF_PRODUCTS_PRESENTATIONS:
      return { ...state, presentations: action.payload };
    case DELETE_PRODUCTS_PRESENTATIONS:
      const presentationsDelete = state.presentations.filter((presentation) => {
        return presentation._id !== action.payload;
      });
      return { ...state, presentations: presentationsDelete };
    case CREATE_PRODUCT:
      var productsList = Array.from(state.productsList);
      productsList.push(action.payload);
      return { ...state, productsList, isLoadingProductsList: false };
    case ERROR_PRODUCT:
      return { ...state, isLoadingProductsList: false };
    case DELETE_PRODUCT:
      return {
        ...state,
        productsList: state.productsList.filter(
          (product) => product._id !== action.payload
        ),
        isLoadingProductsList: false,
      };
    case EDIT_PRODUCT:
      var productsListEdit = state.productsList;
      productsListEdit.map((product) => {
        if (product._id === action.payload._id) {
          product.code = action.payload.code;
          product.image = action.payload.image;
          product.name = action.payload.name;
          product.description = action.payload.description;
          product.categoryId = action.payload.categoryId;
          product.subcategoryId = action.payload.subcategoryId;
          console.log();
        }
        return product
      });
      return {
        ...state,
        productsList: productsListEdit,
        isLoadingProductsList: false,
      };
    default:
      return state;
  }
}
